import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { FiDollarSign, FiGift } from "react-icons/fi";

/**
 * Read-only admin notifications derived from existing tables
 * (pending payments + pending withdrawals). No writes, no schema changes.
 */
export default function useAdminNotifications() {
    const [notifications, setNotifications] = useState([]);

    const fetchAll = async () => {
        try {
            const [pembayaranRes, penarikanRes] = await Promise.all([
                supabase.from("pembayaran").select("id, kode_toko, amount, created_at").eq("keterangan", "pending"),
                supabase.from("penarikan").select("id, user_id, jumlah, created_at").eq("status", "pending"),
            ]);

            const pembayaran = pembayaranRes.data || [];
            const penarikan = penarikanRes.data || [];

            const items = [];

            if (pembayaran.length > 0) {
                items.push({
                    title: `${pembayaran.length} pembayaran menunggu`,
                    description: "Perlu verifikasi",
                    tab: "pembayaran",
                    unread: true,
                    icon: FiDollarSign,
                    toneClass: "bg-warning-50 text-warning-600 dark:bg-warning-500/10 dark:text-warning-400",
                });
            }

            if (penarikan.length > 0) {
                items.push({
                    title: `${penarikan.length} penarikan menunggu`,
                    description: "Perlu persetujuan",
                    tab: "penarikan",
                    unread: true,
                    icon: FiGift,
                    toneClass: "bg-danger-50 text-danger-600 dark:bg-danger-500/10 dark:text-danger-400",
                });
            }

            setNotifications(items);
        } catch (err) {
            console.error("Error fetching notifications:", err);
        }
    };

    useEffect(() => {
        fetchAll();

        const pembayaranSub = supabase
            .channel("admin-notif-pembayaran")
            .on("postgres_changes", { event: "*", schema: "public", table: "pembayaran" }, fetchAll)
            .subscribe();

        const penarikanSub = supabase
            .channel("admin-notif-penarikan")
            .on("postgres_changes", { event: "*", schema: "public", table: "penarikan" }, fetchAll)
            .subscribe();

        return () => {
            supabase.removeChannel(pembayaranSub);
            supabase.removeChannel(penarikanSub);
        };
    }, []);

    const badges = {};
    notifications.forEach((n) => {
        if (n.tab) {
            const match = n.title.match(/^(\d+)/);
            badges[n.tab] = match ? parseInt(match[1], 10) : 0;
        }
    });

    return { notifications, badges };
}
